import Stack from 'atoms/Layout/Stack/Stack';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const SpinnerLoadingContainer = styled(Stack)`
  .loading-icon-path {
    transform-origin: center;
    animation: ${rotate} 1s linear infinite;
  }
`;
